export default __webpack_public_path__ + "static/media/cleaning-service.3d4e53f4.jpg";